import debug from 'debug';
import Templates from './templates';

const log = debug('InspirationCatalogsByQuery:Render');

class Render {
	constructor(element, catalogs) {
		this.element = element;
		this.catalogs = catalogs;

		this.initialize();
	}

	initialize() {
		this.render();
	}

	async render() {
		const templates = new Templates();

		this.catalogs.map(catalog => {
			this.element.insertAdjacentHTML('beforeend', templates.listItem(catalog));
		});

	}
}

export default Render;
